import MenuIcon from '@mui/icons-material/Menu'
import { Stack } from '@mui/system';
import { Link } from 'react-router-dom';
import { useTheme, useMediaQuery } from '@mui/material'
import SessionTools from './SessionTools';

export default function Header({appName, authenticated = false}) {
    const theme = useTheme()
    const isXs = useMediaQuery(theme.breakpoints.only('xs'))

    const pushMenu = () => {
        var body = document.body;
        if(body.clientWidth > 768){
            if(body.className.indexOf('sidebar-collapse') === -1){
                body.className += ' sidebar-collapse';
            } else {
                body.className = body.className.replace(' sidebar-collapse', '');
            }
        }else{
            if (body.className.indexOf('sidebar-open') === -1) {
                body.className += ' sidebar-open';
            } else {
                body.className = body.className.replace(' sidebar-open', '');
            }
        }
    }
  
    return (
        <header className="main-header">
            <Link to="/" className={`logo${isXs ? '-xs' : ''}`}>
            {appName}
            </Link>
            <nav className="navbar navbar-static-top" role="navigation">
                <a href="#" className="sidebar-toggle" data-toggle="offcanvas" role="button" onClick={pushMenu}>
                    <MenuIcon/><span className="sr-only"> Toggle navigation</span>
                </a>
                {authenticated && 
                    <Stack direction='row' gap={0}>
                        <SessionTools
                            layoutStyle={{ float: 'right', color: 'white', paddingRight: '1em' }}
                            linkStyle={{ color: 'white', paddingLeft: '1em' }}
                            />
                    </Stack>
                }
            </nav>
        </header>
    )
}